import { createSlice } from "@reduxjs/toolkit";
const initialVal = "uk";
export const currentLangSlice = createSlice({
    name: "currentLang",
    initialState: {
        value: initialVal,
    },
    reducers: {
        setCurrentLanguage: (state, action) => {
            state.value = action.payload;
        },
    },
});
export const { setCurrentLanguage } = currentLangSlice.actions;
export default currentLangSlice.reducer;
